'use client';

import { useAviosAuthCookieManager } from './useAviosAuthCookieManager';

const AviosAuthCookieManager = ({ children }: { children?: React.ReactNode }) => {
  useAviosAuthCookieManager();

  return <>{children}</>;
};

export { AviosAuthCookieManager };
